import { normalize } from 'normalizr';
import store from '@/store';
import * as schemas from '@/schemas';

export const loadEntity = function (type, entity, meta = {}) {
    let schema = schemas[type];
    let normalized = normalize(entity, schema);
    let result = normalized.result;
    meta = Object.assign({}, { type, result }, meta);

    store.commit('data/LOAD_ENTITIES', {
        ...normalized.entities,
        meta,
    });

    return { result, meta };
};

export function loadEntityResponseData(type, responseBody) {
    let meta = Object.assign({}, responseBody);
    delete meta.data;
    return loadEntity(type, responseBody.data, meta);
}
